import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@/modules/components/Box'
import Icon from '@/modules/components/Icon'
import Typography from '@/modules/components/Typography'
import { LowerRegions } from '@/modules/configs/region'

import { LangMenu } from './LangMenu'
import { Modal } from './Modal'
import { RegionMenu } from './RegionMenu'

enum NavBarModalTabKey {
  LANG = 'geolocation.lang_desktop',
  REGION = 'geolocation.location',
}

export const NavBarModal = ({
  isOpen,
  setOpen,
  onSetRegion,
  suggestLangs,
  allLangs,
  suggestRegion,
  allRegion,
}: {
  isOpen: boolean
  setOpen: () => void
  onSetRegion: (region: string) => void
  suggestRegion: LowerRegions[]
  allRegion: LowerRegions[]
  suggestLangs: string[]
  allLangs: string[]
}) => {
  const { t } = useTranslation('navigation')
  const [tabKey, setTabKey] = useState<NavBarModalTabKey>(
    NavBarModalTabKey.LANG
  )

  if (!isOpen) return null

  return (
    <Modal
      onClose={setOpen}
      zIndex={199}
      width={[327, 628, 628]}
      px={[3, 4, 4]}
    >
      <Box
        marginTop={3}
        borderBottom="1px #A0A9BE solid"
        display="flex"
        justifyContent="space-between"
      >
        <Box display="flex" justifyContent="flex-start">
          {Object.keys(NavBarModalTabKey).map((key: any) => {
            const keyVal = (NavBarModalTabKey as any)[key]
            return (
              <Typography
                key={key}
                variant="subtitle2"
                className={`${tabKey === keyVal ? 'active' : ''}`}
                color={tabKey === keyVal ? '#1199FA' : '#A0A9BE'}
                borderBottom={tabKey === keyVal ? '#1199FA 1px solid' : 'none'}
                onClick={() => {
                  setTabKey(keyVal)
                }}
                paddingLeft={3}
                paddingRight={3}
                paddingBottom={1}
                customCss={{
                  userSelect: 'none',
                }}
              >
                {t(keyVal)}
              </Typography>
            )
          })}
        </Box>
        <Icon.Close
          fontSize="20px"
          color="secondaryDarkNavy"
          paddingBottom="16px"
          onClick={setOpen}
        />
      </Box>
      {tabKey === NavBarModalTabKey.LANG ? (
        <LangMenu
          suggestLangs={suggestLangs}
          allLangs={allLangs}
          marginTop={4}
          marginBottom={4}
          onClick={() => setOpen()}
        />
      ) : null}
      {tabKey === NavBarModalTabKey.REGION ? (
        <RegionMenu
          suggestRegion={suggestRegion}
          allRegion={allRegion}
          marginTop={4}
          marginBottom={4}
          onClick={(region) => {
            onSetRegion(region)
          }}
        />
      ) : null}
    </Modal>
  )
}
